import { call, put, takeLatest } from "redux-saga/effects";

import { genericEntitySaga } from "./apiSagas.js";
import { getPDFCall, getTXTCall } from "../../services/api.js";

import { DOWNLOADS } from "../actions/actionConstants.js";

// -- FILE DOWNLOADS -- //

export function* downloadSaga(callType, action) {
  try {
    yield call(genericEntitySaga, callType, DOWNLOADS, undefined, action);
    yield put({ type: DOWNLOADS.GET_COMPLETE });
  } catch (err) {
    console.error("error :: downloadSaga ::", callType, err);
  }
}

// -- WATCHERS -- //

export function* watchDownloadSagas() {
  yield takeLatest(DOWNLOADS.GET_PDF, downloadSaga, getPDFCall);
  yield takeLatest(DOWNLOADS.GET_TXT, downloadSaga, getTXTCall);
}
